import API from "./API";
import axios from "axios";

export const Courses = {

    async getProposal(){
        const url = API.url('/courses/proposal');
        return await axios.get(url);
    },

    async getAll(){
        const url = API.url('/admin/courses');
        return await axios.get(url);
    },

    async getOne(id){
        const url = API.url('/courses/' + id);
        return await axios.get(url);
    },

    async getOneToEnroll(id){
        const url = API.url('/courses/' + id  + '/enroll');
        return await axios.get(url);
    },

    async putAudit(id, data){
        const url = API.url('/admin/courses/' + id + '/audit');
        return await axios.put(url, data);
    },

    async post(data){
        const url = API.url('/admin/courses');
        return await axios.post(url, data);
    },

    async put(data){
        const url = API.url('/admin/courses/' + data.id);
        return await axios.put(url, data);
    },

    async delete(id){
        const url = API.url('/admin/courses/' + id);
        return await axios.delete(url);
    },

}

export default Courses;